import Alert from '@preqin/ui-components/cjs/core/Alerts/Alert';

import { ToastAlertProps } from './types';

export const ToastAlert = ({ showNotification, message, priority }: ToastAlertProps) => {
  return (
    <Alert
      showNotification={showNotification}
      message={message}
      type="toast"
      notificationPosition="left"
      priority={priority}
      size="medium"
    />
  );
};
